import { FEATURE_KEYS } from 'utils/featureConstants';

export const pageFeatures = [
  { feature_key: FEATURE_KEYS.STOCK_MOVEMENTS, url: '/inventory/movements' },
  { feature_key: FEATURE_KEYS.SALES_HISTORY, url: '/sales/history' },
  // Core
  { feature_key: FEATURE_KEYS.DASHBOARD, url: '/dashboard' },
  { feature_key: FEATURE_KEYS.SETTINGS, url: '/settings' },

  // Generic Modules
  { feature_key: FEATURE_KEYS.POS_V2, url: '/pos' }, // Added POS_V2 - prioritized
  { feature_key: FEATURE_KEYS.SALES, url: '/sales' },
  { feature_key: FEATURE_KEYS.INVENTORY, url: '/inventory' },
  { feature_key: FEATURE_KEYS.PRODUCTS, url: '/products' },
  { feature_key: FEATURE_KEYS.STOCK, url: '/stock' },
  { feature_key: FEATURE_KEYS.FUNDS, url: '/funds' },
  { feature_key: FEATURE_KEYS.CUSTOMERS, url: '/customers' },
  { feature_key: FEATURE_KEYS.DEBTS, url: '/debts' },
  { feature_key: FEATURE_KEYS.SUPPLIERS, url: '/suppliers' },
  { feature_key: FEATURE_KEYS.EXPENSES, url: '/expenses' },
  { feature_key: FEATURE_KEYS.WHOLESALE, url: '/sales/wholesale' },
  {
    feature_key: FEATURE_KEYS.PURCHASE_ORDERS,
    url: '/procurement/purchase-orders',
  },
  {
    feature_key: FEATURE_KEYS.DELIVERY_NOTES,
    url: '/procurement/delivery-notes',
  },

  // HRM & Payroll
  { feature_key: FEATURE_KEYS.HRM, url: '/hrm/employees' },
  { feature_key: FEATURE_KEYS.PAYROLL, url: '/hrm/payroll' },

  // Pharmacy
  { feature_key: FEATURE_KEYS.PHARMACY_DASHBOARD, url: '/pharmacy/dashboard' },
  { feature_key: FEATURE_KEYS.PHARMACY_SALES, url: '/pharmacy/pos' }, // POS is main entry
  { feature_key: FEATURE_KEYS.PHARMACY_SALES, url: '/pharmacy/sales-history' },
  { feature_key: FEATURE_KEYS.PHARMACY_POS, url: '/pharmacy/pos' },
  { feature_key: FEATURE_KEYS.PRESCRIPTIONS, url: '/pharmacy/prescriptions' },
  { feature_key: FEATURE_KEYS.MEDICATIONS, url: '/pharmacy/medications' },
  { feature_key: FEATURE_KEYS.PHARMACISTS, url: '/pharmacy/pharmacists' },
  { feature_key: FEATURE_KEYS.PATIENTS, url: '/pharmacy/patients' },
  { feature_key: FEATURE_KEYS.PHARMACY_BATCHES, url: '/pharmacy/batches' },
  { feature_key: FEATURE_KEYS.PHARMACY_REPORTS, url: '/pharmacy/reports' },
  {
    feature_key: FEATURE_KEYS.PHARMACY_PROCUREMENT,
    url: '/pharmacy/purchase-orders',
  },

  // Hospital & Clinical
  { feature_key: FEATURE_KEYS.HOSPITAL_DASHBOARD, url: '/hospital/dashboard' },
  { feature_key: FEATURE_KEYS.CLINICAL_QUEUE, url: '/hospital/queue' },
  { feature_key: FEATURE_KEYS.CLINICAL_QUEUE, url: '/hospital/appointments' },
  { feature_key: FEATURE_KEYS.HOSPITAL_HR, url: '/hospital/hr' },
  { feature_key: FEATURE_KEYS.HOSPITAL_PAYROLL, url: '/hospital/payroll' },
  { feature_key: FEATURE_KEYS.HOSPITAL_WARDS, url: '/hospital/wards' },
  { feature_key: FEATURE_KEYS.HOSPITAL_LABS, url: '/hospital/labs' },
  { feature_key: FEATURE_KEYS.HOSPITAL_MANAGEMENT, url: '/hospital/finance' },
  { feature_key: FEATURE_KEYS.HOSPITAL_DASHBOARD, url: '/hospital/pacs' },
  { feature_key: FEATURE_KEYS.HOSPITAL_DASHBOARD, url: '/hospital/reports' },
  { feature_key: FEATURE_KEYS.CLINICAL_QUEUE, url: '/hospital/ambulance' },

  // Retail
  { feature_key: FEATURE_KEYS.RETAIL_INVENTORY, url: '/retail/inventory' },
  { feature_key: FEATURE_KEYS.RETAIL_SUPPLIERS, url: '/retail/suppliers' },
  { feature_key: FEATURE_KEYS.RETAIL_REPORTS, url: '/retail/reports' },
  { feature_key: FEATURE_KEYS.RETAIL_INVENTORY, url: '/retail/fulfillment' },

  // Bar
  { feature_key: FEATURE_KEYS.BAR_DASHBOARD, url: '/bar/dashboard' },
  { feature_key: FEATURE_KEYS.BAR_POS, url: '/bar/pos' },
  { feature_key: FEATURE_KEYS.COMPTOIRS, url: '/bar/comptoirs' },
  { feature_key: FEATURE_KEYS.BAR_STOCK, url: '/bar/stock' },
  { feature_key: FEATURE_KEYS.BAR_MOVEMENTS, url: '/bar/movements' },
  { feature_key: FEATURE_KEYS.BAR_RECIPES, url: '/bar/recipes' },
  { feature_key: FEATURE_KEYS.BAR_TABS, url: '/bar/tabs' },
  { feature_key: FEATURE_KEYS.BAR_SHIFTS, url: '/bar/shifts' },
  { feature_key: FEATURE_KEYS.BAR_ANALYTICS, url: '/bar/analytics' },
  { feature_key: FEATURE_KEYS.BAR_MENUS, url: '/bar/menus' },

  // Restaurant
  {
    feature_key: FEATURE_KEYS.RESTAURANT_DASHBOARD,
    url: '/restaurant/dashboard',
  },
  { feature_key: FEATURE_KEYS.RESTAURANT_TABLES, url: '/restaurant/tables' },
  {
    feature_key: FEATURE_KEYS.RESTAURANT_RESERVATIONS,
    url: '/restaurant/reservations',
  },
  { feature_key: FEATURE_KEYS.RESTAURANT_KITCHEN, url: '/restaurant/kitchen' },
  {
    feature_key: FEATURE_KEYS.RESTAURANT_REPORTS,
    url: '/restaurant/reports/tables',
  },
  { feature_key: 'GUEST_ORDER', url: '/order/:tableToken' },

  // Coffee Shop
  { feature_key: FEATURE_KEYS.COFFEE_SHOP_DASHBOARD, url: '/coffee-shop/dashboard' },
  { feature_key: FEATURE_KEYS.COFFEE_SHOP_POS, url: '/coffee-shop/pos' },
  { feature_key: FEATURE_KEYS.COFFEE_SHOP_ORDERS, url: '/coffee-shop/orders' },
  { feature_key: FEATURE_KEYS.COFFEE_SHOP_RECIPES, url: '/coffee-shop/recipes' },
  { feature_key: FEATURE_KEYS.COFFEE_SHOP_MODIFIERS, url: '/coffee-shop/modifiers' },
  { feature_key: FEATURE_KEYS.COFFEE_SHOP_SHIFTS, url: '/coffee-shop/shifts' },
  { feature_key: FEATURE_KEYS.COFFEE_SHOP_SPILLAGE, url: '/coffee-shop/spillage' },
  { feature_key: FEATURE_KEYS.COFFEE_SHOP_LOYALTY, url: '/coffee-shop/loyalty' },

  // Owner
  { feature_key: FEATURE_KEYS.OWNER_DASHBOARD, url: '/owner/dashboard' },

  // Domain Microservices - Grocery & Supermarket
  { feature_key: FEATURE_KEYS.GROCERY_DASHBOARD, url: '/grocery/dashboard' },
  { feature_key: FEATURE_KEYS.GROCERY_POS, url: '/grocery/pos' },
  { feature_key: FEATURE_KEYS.GROCERY_INVENTORY, url: '/grocery/inventory' },
  { feature_key: FEATURE_KEYS.GROCERY_EXPIRIES, url: '/grocery/expiries' },
  { feature_key: FEATURE_KEYS.GROCERY_SPOILAGE, url: '/grocery/spoilage' },
  { feature_key: FEATURE_KEYS.SALES_HISTORY, url: '/grocery/sales-history' },
  { feature_key: FEATURE_KEYS.GROCERY_REPORTS, url: '/grocery/reports' },
  { feature_key: FEATURE_KEYS.CLOTHING_DASHBOARD, url: '/clothing/dashboard' },
  { feature_key: FEATURE_KEYS.SHOE_DASHBOARD, url: '/shoe/dashboard' },
  { feature_key: FEATURE_KEYS.SHOE_POS, url: '/shoe/pos' },
  { feature_key: FEATURE_KEYS.SHOE_PREPACKS, url: '/shoe/prepacks' },
  { feature_key: FEATURE_KEYS.SHOE_AUDITS, url: '/shoe/audits' },
  { feature_key: FEATURE_KEYS.SHOE_MISMATCHED, url: '/shoe/mismatched' },
  { feature_key: FEATURE_KEYS.SHOE_CARE, url: '/shoe/care' },
  { feature_key: FEATURE_KEYS.SHOE_LABELS, url: '/shoe/labels' },
  { feature_key: FEATURE_KEYS.SHOE_SIZE_CONVERTER, url: '/shoe/size-converter' },
  { feature_key: FEATURE_KEYS.SALES_HISTORY, url: '/shoe/sales-history' },
  { feature_key: FEATURE_KEYS.HARDWARE_DASHBOARD, url: '/hardware/dashboard' },
  { feature_key: FEATURE_KEYS.PRODUCTS, url: '/hardware' },
  { feature_key: FEATURE_KEYS.PRODUCTS, url: '/hardware/catalog' },
  { feature_key: FEATURE_KEYS.HARDWARE_DASHBOARD, url: '/hardware/rentals' },
  { feature_key: FEATURE_KEYS.HARDWARE_DASHBOARD, url: '/tool-rentals' },
  { feature_key: FEATURE_KEYS.POS_V2, url: '/hardware/pos' },
  { feature_key: FEATURE_KEYS.DEBTS, url: '/hardware/debts' },
  { feature_key: FEATURE_KEYS.SALES_ANALYTICS, url: '/hardware/analytics' },
  { feature_key: FEATURE_KEYS.CUSTOMERS, url: '/hardware/customers' },
  { feature_key: FEATURE_KEYS.REPORTS, url: '/hardware/reports' },
  { feature_key: FEATURE_KEYS.JEWELRY_DASHBOARD, url: '/jewelry/dashboard' },
  { feature_key: FEATURE_KEYS.JEWELRY_VAULT, url: '/jewelry/vault' },
  { feature_key: FEATURE_KEYS.JEWELRY_POS, url: '/jewelry/pos' },
  { feature_key: FEATURE_KEYS.SALES_HISTORY, url: '/jewelry/sales-history' },
  { feature_key: FEATURE_KEYS.JEWELRY_CERTIFICATES, url: '/jewelry/certificates' },
  { feature_key: FEATURE_KEYS.JEWELRY_TRADE_INS, url: '/jewelry/trade-ins' },
  { feature_key: FEATURE_KEYS.JEWELRY_SPOT_RATES, url: '/jewelry/spot-rates' },
  { feature_key: FEATURE_KEYS.JEWELRY_REPORTS, url: '/jewelry/reports' },

  // Mobile Money & Agency Banking
  { feature_key: FEATURE_KEYS.MOBILE_MONEY_DASHBOARD, url: '/mobile-money/dashboard' },
  { feature_key: FEATURE_KEYS.MOBILE_MONEY_POS, url: '/mobile-money/pos' },
  { feature_key: FEATURE_KEYS.MOBILE_MONEY_FLOATS, url: '/mobile-money/floats' },
  { feature_key: FEATURE_KEYS.MOBILE_MONEY_LEDGER, url: '/mobile-money/ledger' },
  { feature_key: FEATURE_KEYS.MOBILE_MONEY_RECONCILIATION, url: '/mobile-money/reconciliation' },

  // Hotel & Hospitality PMS
  { feature_key: FEATURE_KEYS.HOTEL_DASHBOARD, url: '/hotel/dashboard' },
  { feature_key: FEATURE_KEYS.HOTEL_ROOMS, url: '/hotel/rooms' },
  { feature_key: FEATURE_KEYS.HOTEL_RESERVATIONS, url: '/hotel/reservations' },
  { feature_key: FEATURE_KEYS.HOTEL_HOUSEKEEPING, url: '/hotel/housekeeping' },
  { feature_key: FEATURE_KEYS.HOTEL_FOLIOS, url: '/hotel/folios' },
  { feature_key: FEATURE_KEYS.HOTEL_REPORTS, url: '/hotel/reports' },
  { feature_key: FEATURE_KEYS.HOTEL_GUESTS, url: '/hotel/guests' },

  // Added Audit Logs at the bottom so it is evaluated last for fallback
  { feature_key: FEATURE_KEYS.AUDIT_LOGS, url: '/reports/audit-logs' },
];
export default {
  landingPage: '/',
  login: '/login',
  dashboard: '/dashboard',
  register: '/register',
  sales: '/sales',
  pos: '/pos',
  salesHistory: '/sales/history',
  inventory: '/inventory',
  products: '/products',
  funds: '/fund',
  expenses: '/expenses',
  archivedStock: '/archived-stock',
  settings: '/settings',
  customers: '/customers',
  productCategory: '/product-category',
  debts: '/debts',
  resetPassword: '/reset-password',
  pageNotFound: '/page-not-found',
  suppliers: '/suppliers',
  stock: '/stock',
  manageBranchs: '/manage-branchs',
  salesV2: '/v2',
  wholesale: '/sales/wholesale',

  // Analytics routes
  salesAnalytics: '/analytics/sales',
  inventoryAnalytics: '/analytics/inventory',
  customerAnalytics: '/analytics/customers',
  financialAnalytics: '/analytics/financial',
  stockMovements: '/inventory/movements',

  // Procurement
  purchaseOrders: '/procurement/purchase-orders',
  createPurchaseOrder: '/procurement/purchase-orders/create',
  deliveryNotes: '/procurement/delivery-notes',
  deliveryNoteDetails: '/procurement/delivery-notes/:id',
  createDeliveryNote: '/procurement/delivery-notes/create',
  pharmacyDashboard: '/pharmacy/dashboard',
  prescriptions: '/pharmacy/prescriptions',
  createPrescription: '/pharmacy/prescriptions/create',
  medications: '/pharmacy/medications',
  pharmacists: '/pharmacy/pharmacists',
  createPatient: '/pharmacy/patients/create',
  patients: '/pharmacy/patients',
  patientHistory: '/pharmacy/patients/:id',
  pharmacyDispensing: '/pharmacy/dispensing',
  pharmacyBatches: '/pharmacy/batches',
  pharmacyPOS: '/pharmacy/pos',
  pharmacySalesHistory: '/pharmacy/sales-history',
  pharmacyBranches: '/pharmacy/branches',
  pharmacyReports: '/pharmacy/reports',
  // Pharmacy Procurement
  pharmacyPurchaseOrders: '/pharmacy/purchase-orders',
  pharmacyPurchaseOrderDetail: '/pharmacy/purchase-orders/:id',
  pharmacyPurchaseOrderEdit: '/pharmacy/purchase-orders/:id/edit',
  pharmacyStockTransfers: '/pharmacy/stock-transfers',
  pharmacyCreateStockTransfer: '/pharmacy/stock-transfers/create',
  pharmacyStockTransferDetail: '/pharmacy/stock-transfers/:id',
  pharmacyGoodsReceiving: '/pharmacy/goods-receiving',
  pharmacyGoodsReceivingCreate: '/pharmacy/goods-receiving/create',
  pharmacyGoodsReceivingDetail: '/pharmacy/goods-receiving/:id',

  // Retail (shop, boutique, store, supermarket)
  retailInventory: '/retail/inventory',
  retailSuppliers: '/retail/suppliers',
  retailReports: '/retail/reports',
  storeFulfillment: '/retail/fulfillment',

  // Branch Management
  branchPricing: '/branches/pricing',
  branchTransfers: '/branches/transfers',
  branchSettings: '/branches/settings',
  branchReports: '/branches/reports',

  barDashboard: '/bar/dashboard',
  barPOS: '/bar/pos',
  comptoirs: '/bar/comptoirs',
  barStock: '/bar/stock',
  barMovements: '/bar/movements',
  barRecipes: '/bar/recipes',
  recipeDetails: '/bar/recipes/:id',
  createRecipe: '/bar/recipes/create',
  barRecipeEdit: '/bar/recipes/:id/edit',
  barTabs: '/bar/tabs',
  barShifts: '/bar/shifts',
  barAnalytics: '/bar/analytics',
  barMenus: '/bar/menus',
  barManageMenu: '/bar/menus/:id',
  barBottles: '/bar/bottles',

  // Coffee Shop
  coffeeDashboard: '/coffee-shop/dashboard',
  coffeePOS: '/coffee-shop/pos',
  coffeeOrders: '/coffee-shop/orders',
  coffeeRecipes: '/coffee-shop/recipes',
  coffeeModifiers: '/coffee-shop/modifiers',
  coffeeShifts: '/coffee-shop/shifts',
  coffeeSpillage: '/coffee-shop/spillage',
  coffeeLoyalty: '/coffee-shop/loyalty',

  // Owner Dashboard (cross-branch global views)
  ownerDashboard: '/owner/dashboard',

  // Website Management (Fukkoni marketing site)
  websitePricingPlans: '/website/pricing-plans',
  websiteVisitors: '/website/visitors',

  // Super Admin Portal
  superAdminLogin: '/super-admin/login',
  superAdminDashboard: '/super-admin',
  superAdminShops: '/super-admin/shops',
  superAdminUsers: '/super-admin/users',
  superAdminActivity: '/super-admin/activity',
  superAdminPayments: '/super-admin/payments',
  superAdminSettings: '/super-admin/settings',
  superAdminStorefronts: '/super-admin/storefronts',
  subscriptionRenew: '/renew',

  auditLogs: '/reports/audit-logs',
  reports: '/reports',

  // Restaurant
  restaurantDashboard: '/restaurant/dashboard',
  restaurantTables: '/restaurant/tables',
  restaurantReservations: '/restaurant/reservations',
  restaurantKitchen: '/restaurant/kitchen',
  restaurantTableReports: '/restaurant/reports/tables',
  guestOrder: '/order/:tableToken',
  restaurantTableTerms: '/restaurant/settings/table-terms',
  restaurantOrderingSettings: '/restaurant/settings/ordering',

  // Hospital & Clinical EMR
  hospitalQueue: '/hospital/queue',
  hospitalAppointments: '/hospital/appointments',
  hospitalTriage: '/hospital/triage/:encounterId',
  hospitalConsultation: '/hospital/consultation/:encounterId',
  hospitalDashboard: '/hospital/dashboard',
  hospitalHR: '/hospital/hr',
  hospitalPayroll: '/hospital/payroll',
  hospitalManagement: '/hospital/management',
  hospitalWards: '/hospital/wards',
  hospitalLabs: '/hospital/labs',
  hospitalFinance: '/hospital/finance',
  hospitalPACS: '/hospital/pacs',
  hospitalReports: '/hospital/reports',
  hospitalSettings: '/hospital/settings',
  hospitalAmbulance: '/hospital/ambulance',

  // HRM & Payroll
  hrmEmployees: '/hrm/employees',
  hrmPayroll: '/hrm/payroll',

  // Domain Microservices
  groceryDashboard: '/grocery/dashboard',
  groceryPOS: '/grocery/pos',
  groceryInventory: '/grocery/inventory',
  groceryExpiries: '/grocery/expiries',
  grocerySpoilage: '/grocery/spoilage',
  grocerySalesHistory: '/grocery/sales-history',
  groceryReports: '/grocery/reports',
  clothingDashboard: '/clothing/dashboard',
  shoeDashboard: '/shoe/dashboard',
  shoeCatalog: '/shoe/catalog',
  shoePOS: '/shoe/pos',
  shoePrepacks: '/shoe/prepacks',
  shoeAudits: '/shoe/audits',
  shoeMismatched: '/shoe/mismatched',
  shoeCare: '/shoe/care',
  shoeLabels: '/shoe/labels',
  shoeSizeConverter: '/shoe/size-converter',
  shoeSalesHistory: '/shoe/sales-history',
  shoeDebts: '/shoe/debts',
  hardwareDashboard: '/hardware/dashboard',
  hardwareCatalog: '/hardware',
  hardwareCatalogAlt: '/hardware/catalog',
  hardwareRentals: '/hardware/rentals',
  hardwareRentalsAlt: '/tool-rentals',
  hardwarePOS: '/hardware/pos',
  hardwareDebts: '/hardware/debts',
  hardwareAnalytics: '/hardware/analytics',
  hardwareCustomers: '/hardware/customers',
  hardwareReports: '/hardware/reports',
  jewelryDashboard: '/jewelry/dashboard',
  jewelryVault: '/jewelry/vault',
  jewelryPOS: '/jewelry/pos',
  jewelrySalesHistory: '/jewelry/sales-history',
  jewelryCertificates: '/jewelry/certificates',
  jewelryTradeIns: '/jewelry/trade-ins',
  jewelrySpotRates: '/jewelry/spot-rates',
  jewelryReports: '/jewelry/reports',

  // Mobile Money & Agency Banking
  mobileMoneyDashboard: '/mobile-money/dashboard',
  mobileMoneyPOS: '/mobile-money/pos',
  mobileMoneyFloats: '/mobile-money/floats',
  mobileMoneyLedger: '/mobile-money/ledger',
  mobileMoneyReconciliation: '/mobile-money/reconciliation',
  mobileMoneyDebts: '/mobile-money/debts',
  mobileMoneyCustomerHistory: '/mobile-money/customer-history',
  mobileMoneyTransactionsCustomerHistory: '/mobile-money/transactions/customer-history',
  mobileMoneyReports: '/mobile-money/reports',

  // FUKKONI Online Storefront & Social Commerce
  merchantOnlineStore: '/online-store',
  storefrontProducts: '/online-store/products',
  storefrontOrders: '/online-store/orders',
  storefrontSettings: '/settings/storefront',

  // Hotel & Hospitality PMS
  hotelDashboard: '/hotel/dashboard',
  hotelRooms: '/hotel/rooms',
  hotelReservations: '/hotel/reservations',
  hotelHousekeeping: '/hotel/housekeeping',
  hotelFolios: '/hotel/folios',
  hotelReports: '/hotel/reports',
  hotelGuests: '/hotel/guests',

  // 1. Real Estate & Property Management
  realEstateDashboard: '/real-estate/dashboard',
  realEstateProperties: '/real-estate/properties',
  realEstateUnits: '/real-estate/units',
  realEstateRentPayments: '/real-estate/rent-payments',
  realEstateMaintenance: '/real-estate/maintenance',

  // 2. Barbershop & Men's Grooming
  barbershopDashboard: '/barbershop/dashboard',
  barbershopPOS: '/barbershop/pos',
  barbershopQueue: '/barbershop/pos',
  barbershopChairs: '/barbershop/chairs',
  barbershopServices: '/barbershop/services',

  // 3. Spa & Wellness Sanctuary
  spaDashboard: '/spa/dashboard',
  spaBookings: '/spa/bookings',
  spaRooms: '/spa/rooms',
  spaTreatments: '/spa/treatments',
  spaMemberships: '/spa/memberships',

  // 4. Tailoring & Custom Couture Atelier
  tailoringDashboard: '/tailoring/dashboard',
  tailoringOrders: '/tailoring/orders',
  tailoringMeasurements: '/tailoring/measurements',
  tailoringFabrics: '/tailoring/fabrics',

  // 5. Professional Services & Consulting
  professionalServicesDashboard: '/professional-services/dashboard',
  professionalServicesProjects: '/professional-services/projects',
  professionalServicesTimesheets: '/professional-services/timesheets',
  professionalServicesRetainers: '/professional-services/retainers',

  // 6. Hair Salon & Beauty Studio
  salonDashboard: '/salon/dashboard',
  salonAppointments: '/salon/appointments',
  salonStations: '/salon/stations',
  salonServices: '/salon/services',
  salonFormulas: '/salon/formulas',

  // 7. Car Rental & Fleet Operations
  carRentalDashboard: '/car-rental/dashboard',
  carRentalVehicles: '/car-rental/vehicles',
  carRentalAgreements: '/car-rental/agreements',
  carRentalRentals: '/car-rental/agreements',
  carRentalInspections: '/car-rental/inspections',
};
